import React, { FC, useCallback } from 'react';
import { logOut } from 'actions/auth';
import { useDispatch } from 'react-redux';
import { resetUserData } from 'actions/users';
import { resetScholarsData } from 'actions/scholars';
import { resetGlobalState } from 'actions/app-state';
import PlaceholderImage from 'style/imgs/aneta_robot.svg';
import DangerIcon from 'style/imgs/icons/danger.svg';
// import closeIcon from 'style/imgs/icons/close-icon.svg';
import styles from './index.module.scss';

interface Props {
  modalClose: () => void;
}
const SubscriptionExpiredPopUp: FC<Props> = () => {
  const dispatch = useDispatch();

  const onSignOut = useCallback(() => {
    dispatch(resetUserData());
    dispatch(resetScholarsData());
    dispatch(resetGlobalState());
    dispatch(logOut());
  }, [dispatch]);

  return (
    <div className={styles.root}>
      {/* <div
        role="button"
        className={styles.modalClose}
        tabIndex={0}
        onKeyDown={modalClose}
        onClick={modalClose}
      >
        <img src={closeIcon} alt="close" />
      </div> */}
      <div className={styles.content}>
        <div className={styles.content_robot}>
          <img src={PlaceholderImage} alt="Placeholder" />
          <div className={styles.poster}>
            <div>
              <div>
                <img src={DangerIcon} alt="Danger" />
              </div>
              <div>
                <span>Subscription expired</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.content_info}>
          <h4>Get a Grown Up</h4>
          <span>
            Please proceed to a web version of the app to provide your payment
            details.
          </span>
          <p>
            To log out of the app press{' '}
            <span
              role="button"
              onKeyDown={() => null}
              onClick={onSignOut}
              tabIndex={0}
            >
              here
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpiredPopUp;
